export const getZoneConditions = (deal) => {
  const conditions = {
    is_soldout: deal.buy_button?.is_ended === true,
    is_private: deal.deal_status === 'Private',
    is_public: deal.deal_status === 'Public',
    is_ended: deal.deal_status === 'Ended',
    is_info: deal.deal_status === 'Info',
    is_legacy: deal.deal_status === 'Legacy',
  };

  if (deal.participation) {
    deal.participation.forEach((participates) => {
      conditions[`participates_${participates}`] = true;
    });
  }

  const internalProductTags = deal.products[0]?.internalProductTags || [];
  if (internalProductTags) {
    internalProductTags.forEach((tag) => {
      conditions[`internal_${tag}`] = true;
    });
  }

  return conditions;
};

// takes an array or object of conditions and turns into a comma-separated string
// ['is_soldout'] => ['is_soldout']
// { is_soldout: true, is_info: false } => ['is_soldout']
export const formatConditions = (conditions) => {
  let ret = [];

  if (Array.isArray(conditions)) {
    ret = [...conditions];
  } else if (conditions && conditions.constructor === Object.prototype.constructor) {
    Object.keys(conditions).forEach((condition) => {
      const v = !!conditions[condition];

      if (v) {
        ret.push(condition);
      }
    });
  }

  return ret.join(',');
};
